<div class="service-channel-page" [testId]="'channel-main-card'">
  <div class="page-topbar">
    <div class="header-section" [testId]="'channel-card-header'">
      <div class="title-section">
        <h3 class="page-title" [testId]="'channel-title'">{{ 'tenant.channel.personal.title' | i18n }}</h3>
      </div>
      <div class="header-actions">
        <button nz-button nzType="default" class="line-guide-trigger" (click)="openLineGuide()" [testId]="'channel-line-guide-button'">
          <i nz-icon nzType="book"></i>
          {{ 'servicenumber.channel.line-guide-action' | i18n }}
        </button>
        <button nz-button nzType="default" [nzLoading]="loading" (click)="loadChannelData()" [testId]="'channel-refresh-button'">
          <i nz-icon nzType="reload" nzTheme="outline"></i>
          <span>{{ 'common.refresh' | i18n }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="channel-card-grid">
    <nz-row [nzGutter]="16">
      <!-- Line渠道 -->
      <nz-col [nzXs]="24" [nzMd]="12" [nzXl]="8" [testId]="'line-channel-block'">
        <nz-card class="channel-card card-line" [nzLoading]="loading">
          <div class="card-header" [testId]="'line-channel-header'">
            <div class="card-head-main" [testId]="'line-channel-title'">
              <img
                src="./assets/images/channels/icon-im-line.svg"
                [alt]="'tenant.channel.personal.line-oa.title' | i18n"
                class="card-icon"
                [testId]="'line-channel-icon'"
              />
              <div class="card-title" [testId]="'line-channel-name'">{{ 'tenant.channel.personal.line-oa.title' | i18n }}</div>
            </div>
            <div class="card-status" *ngIf="isChannelAvailable(lineChannel)" [testId]="'line-channel-status'">
              <i nz-icon nzType="check-circle" nzTheme="fill"></i>
              <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
            </div>
            <div
              class="card-status"
              [ngClass]="getChannelStatusClass(lineChannel)"
              *ngIf="getChannelStatusText(lineChannel)"
              [testId]="'line-channel-processing-status'"
            >
              <i nz-icon [nzType]="getChannelStatusClass(lineChannel) ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
              <span>{{ getChannelStatusText(lineChannel) }}</span>
            </div>
          </div>

          <div class="card-body">
            <p class="card-desc">{{ 'servicenumber.channel.line.desc' | i18n }}</p>
            <div *ngIf="!lineChannel && isLineBindDisabled()" class="bind-prerequisite-hint" [testId]="'line-bind-prerequisite-hint'">
              <i nz-icon nzType="info-circle" nzTheme="fill"></i>
              <span>{{ getLineBindDisabledMessage() }}</span>
            </div>
            <div *ngIf="lineChannel" class="channel-info channel-info-compact" [testId]="'line-channel-info'">
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.name' | i18n }}：</span>
                <span class="value">{{ lineChannel.name }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.channel-id' | i18n }}：</span>
                <span class="value">{{ lineChannel.channelId }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.channel-secret' | i18n }}：</span>
                <span class="value value-with-action">
                  <span>{{ showLineSecret ? lineChannel.channelSecret : maskToken(lineChannel.channelSecret) }}</span>
                  <button nz-button nzType="link" nzSize="small" (click)="toggleLineSecret()" [testId]="'line-secret-toggle-button'">
                    <i
                      nz-icon
                      [nzType]="showLineSecret ? 'eye-invisible' : 'eye'"
                      nzTheme="outline"
                      [testId]="'line-secret-toggle-icon'"
                    ></i>
                  </button>
                </span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.bot-basic-id' | i18n }}：</span>
                <span class="value">{{ lineChannel.botBasicId }}</span>
              </div>
              <div class="info-item" *ngIf="lineChannel.providerId">
                <span class="label">{{ 'servicenumber.channel.provider-id' | i18n }}：</span>
                <span class="value">{{ lineChannel.providerId }}</span>
              </div>
              <div class="info-item" *ngIf="lineChannel.messageTotalCount !== undefined">
                <span class="label">{{ 'servicenumber.channel.total-messages' | i18n }}：</span>
                <span class="value">{{ lineChannel.messageTotalCount || 0 }}</span>
              </div>
              <div class="info-item" *ngIf="lineChannel.messageRemainCount !== undefined">
                <span class="label">{{ 'servicenumber.channel.remaining-messages' | i18n }}：</span>
                <span class="value">{{ lineChannel.messageRemainCount || 0 }}</span>
              </div>
              <div class="info-item" *ngIf="lineChannel.messageUsedCount !== undefined">
                <span class="label">{{ 'servicenumber.channel.used-messages' | i18n }}：</span>
                <span class="value">{{ lineChannel.messageUsedCount || 0 }}</span>
              </div>
              <div class="info-item line-group-send-setting">
                <span class="label">允許向 LineGroup 主動推送：</span>
                <nz-switch
                  [nzControl]="true"
                  [ngModel]="isLineGroupSendAllowed()"
                  [nzLoading]="lineGroupSendUpdating"
                  (click)="onLineGroupSendChange($event)"
                  [nzDisabled]="!isChannelAvailable(lineChannel)"
                  [testId]="'line-group-send-switch'"
                />
              </div>
            </div>
            <div class="card-error" *ngIf="getChannelFailureReason(lineChannel)" [testId]="'line-channel-failure-reason'">
              <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
              <span>{{ getChannelFailureReason(lineChannel) }}</span>
            </div>
          </div>

          <div class="card-actions" [testId]="'line-channel-actions'">
            <button
              *ngIf="!lineChannel"
              nz-button
              nzType="primary"
              [disabled]="isLineBindDisabled()"
              (click)="showLineBindModal()"
              [testId]="'line-bind-button'"
            >
              {{ 'tenant.channel.personal.connect' | i18n }}
            </button>
            <button
              *ngIf="lineChannel"
              nz-button
              nzType="default"
              (click)="unbindLine()"
              [nzLoading]="lineUnbindLoading"
              [testId]="'line-unbind-button'"
            >
              {{ 'tenant.channel.personal.disconnect' | i18n }}
            </button>
          </div>
        </nz-card>
      </nz-col>

      <!-- Facebook渠道 -->
      <nz-col [nzXs]="24" [nzMd]="12" [nzXl]="8" [testId]="'facebook-channel-block'">
        <nz-card class="channel-card card-facebook" [nzLoading]="loading">
          <div class="card-header" [testId]="'facebook-channel-header'">
            <div class="card-head-main" [testId]="'facebook-channel-title'">
              <img
                src="./assets/images/channels/icon-im-fb.svg"
                [alt]="'tenant.channel.personal.facebook.title' | i18n"
                class="card-icon"
                [testId]="'facebook-channel-icon'"
              />
              <div class="card-title" [testId]="'facebook-channel-name'">{{ 'tenant.channel.personal.facebook.title' | i18n }}</div>
            </div>
            <div class="card-status" *ngIf="isChannelAvailable(facebookChannel)" [testId]="'facebook-channel-status'">
              <i nz-icon nzType="check-circle" nzTheme="fill"></i>
              <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
            </div>
            <div
              class="card-status"
              [ngClass]="getChannelStatusClass(facebookChannel)"
              *ngIf="getChannelStatusText(facebookChannel)"
              [testId]="'facebook-channel-processing-status'"
            >
              <i nz-icon [nzType]="getChannelStatusClass(facebookChannel) ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
              <span>{{ getChannelStatusText(facebookChannel) }}</span>
            </div>
          </div>

          <div class="card-body">
            <p class="card-desc">{{ 'tenant.channel.personal.facebook.desc' | i18n }}</p>
            <div *ngIf="facebookChannel" class="channel-info channel-info-compact" [testId]="'facebook-channel-info'">
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.name' | i18n }}：</span>
                <span class="value">{{ facebookChannel.name }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.page-id' | i18n }}：</span>
                <span class="value">{{ facebookChannel.code }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.access-token' | i18n }}：</span>
                <span class="value value-with-action">
                  <span>{{ showFacebookToken ? facebookChannel.accessToken : maskToken(facebookChannel.accessToken) }}</span>
                  <button nz-button nzType="link" nzSize="small" (click)="toggleFacebookToken()" [testId]="'facebook-token-toggle-button'">
                    <i
                      nz-icon
                      [nzType]="showFacebookToken ? 'eye-invisible' : 'eye'"
                      nzTheme="outline"
                      [testId]="'facebook-token-toggle-icon'"
                    ></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="card-error" *ngIf="getChannelFailureReason(facebookChannel)" [testId]="'facebook-channel-failure-reason'">
              <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
              <span>{{ getChannelFailureReason(facebookChannel) }}</span>
            </div>
          </div>

          <div class="card-actions" [testId]="'facebook-channel-actions'">
            <button *ngIf="!facebookChannel" nz-button nzType="primary" (click)="loginWithFacebook()" [testId]="'facebook-bind-button'">
              {{ 'tenant.channel.personal.connect' | i18n }}
            </button>
            <button
              *ngIf="facebookChannel"
              nz-button
              nzType="default"
              (click)="unbindFacebook()"
              [nzLoading]="facebookUnbindLoading"
              [testId]="'facebook-unbind-button'"
            >
              {{ 'tenant.channel.personal.disconnect' | i18n }}
            </button>
          </div>
        </nz-card>
      </nz-col>

      <!-- Instagram渠道 -->
      <nz-col [nzXs]="24" [nzMd]="12" [nzXl]="8" [testId]="'instagram-channel-block'">
        <nz-card class="channel-card card-instagram" [nzLoading]="loading">
          <div class="card-header" [testId]="'instagram-channel-header'">
            <div class="card-head-main" [testId]="'instagram-channel-title'">
              <img
                src="./assets/images/channels/icon-im-ig.svg"
                [alt]="'tenant.channel.personal.instagram.title' | i18n"
                class="card-icon"
                [testId]="'instagram-channel-icon'"
              />
              <div class="card-title" [testId]="'instagram-channel-name'">{{ 'tenant.channel.personal.instagram.title' | i18n }}</div>
            </div>
            <div class="card-status" *ngIf="isChannelAvailable(instagramChannel)" [testId]="'instagram-channel-status'">
              <i nz-icon nzType="check-circle" nzTheme="fill"></i>
              <span>{{ 'tenant.channel.personal.connected' | i18n }}</span>
            </div>
            <div
              class="card-status"
              [ngClass]="getChannelStatusClass(instagramChannel)"
              *ngIf="getChannelStatusText(instagramChannel)"
              [testId]="'instagram-channel-processing-status'"
            >
              <i nz-icon [nzType]="getChannelStatusClass(instagramChannel) ? 'close-circle' : 'info-circle'" nzTheme="fill"></i>
              <span>{{ getChannelStatusText(instagramChannel) }}</span>
            </div>
          </div>

          <div class="card-body">
            <p class="card-desc">{{ 'tenant.channel.personal.instagram.desc' | i18n }}</p>
            <div *ngIf="instagramChannel" class="channel-info channel-info-compact" [testId]="'instagram-channel-info'">
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.name' | i18n }}：</span>
                <span class="value">{{ instagramChannel.name }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.instagram-id' | i18n }}：</span>
                <span class="value">{{ instagramChannel.code }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.bot-name' | i18n }}：</span>
                <span class="value">{{ instagramChannel.ig_botName }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.instagram-name' | i18n }}：</span>
                <span class="value">{{ instagramChannel.ig_name }}</span>
              </div>
              <div class="info-item" *ngIf="instagramChannel.groupCode">
                <span class="label">{{ 'servicenumber.channel.group-code' | i18n }}：</span>
                <span class="value">{{ instagramChannel.groupCode }}</span>
              </div>
              <div class="info-item">
                <span class="label">{{ 'servicenumber.channel.access-token' | i18n }}：</span>
                <span class="value value-with-action">
                  <span>{{ showInstagramToken ? instagramChannel.accessToken : maskToken(instagramChannel.accessToken) }}</span>
                  <button
                    nz-button
                    nzType="link"
                    nzSize="small"
                    (click)="toggleInstagramToken()"
                    [testId]="'instagram-token-toggle-button'"
                  >
                    <i
                      nz-icon
                      [nzType]="showInstagramToken ? 'eye-invisible' : 'eye'"
                      nzTheme="outline"
                      [testId]="'instagram-token-toggle-icon'"
                    ></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="card-error" *ngIf="getChannelFailureReason(instagramChannel)" [testId]="'instagram-channel-failure-reason'">
              <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
              <span>{{ getChannelFailureReason(instagramChannel) }}</span>
            </div>
          </div>

          <div class="card-actions" [testId]="'instagram-channel-actions'">
            <button *ngIf="!instagramChannel" nz-button nzType="primary" (click)="loginWithInstagram()" [testId]="'instagram-bind-button'">
              {{ 'tenant.channel.personal.connect' | i18n }}
            </button>
            <button
              *ngIf="instagramChannel"
              nz-button
              nzType="default"
              (click)="unbindInstagram()"
              [nzLoading]="instagramUnbindLoading"
              [testId]="'instagram-unbind-button'"
            >
              {{ 'tenant.channel.personal.disconnect' | i18n }}
            </button>
          </div>
        </nz-card>
      </nz-col>
    </nz-row>
  </div>

  <nz-card class="usage-card">
    <div class="usage-header">
      <h4 class="usage-title">{{ 'servicenumber.channel.guide.title' | i18n }}</h4>
    </div>
    <div class="usage-content">
      <ul class="usage-list">
        <li>{{ 'servicenumber.channel.guide.item1' | i18n }}</li>
        <li>{{ 'servicenumber.channel.guide.item2' | i18n }}</li>
        <li>{{ 'servicenumber.channel.guide.item3' | i18n }}</li>
        <li>{{ 'servicenumber.channel.guide.item4' | i18n }}</li>
      </ul>
    </div>
  </nz-card>

  <nz-card class="third-party-card">
    <div class="third-party-header">
      <div>
        <h4 class="third-party-title">{{ 'servicenumber.channel.third-party.title' | i18n }}</h4>
        <p class="third-party-subtitle">{{ 'servicenumber.channel.third-party.subtitle' | i18n }}</p>
      </div>
      <button nz-button nzType="primary" type="button" (click)="openThirdPartyBindingModal()" testId="channel-third-party-bind-button">
        {{ 'servicenumber.channel.third-party.bind-action' | i18n }}
      </button>
    </div>

    <div class="third-party-note third-party-note-primary">
      {{ 'servicenumber.channel.third-party.note.primary' | i18n }}
    </div>
    <div class="third-party-note">
      {{ 'servicenumber.channel.third-party.note.secondary' | i18n }}
    </div>

    <div class="third-party-list-header">{{ 'servicenumber.channel.third-party.bound-list-title' | i18n }}</div>

    <nz-spin [nzSpinning]="thirdPartyBindingLoading">
      <ng-container *ngIf="thirdPartyBindings.length; else emptyThirdPartyBindings">
        <div class="binding-list">
          <div class="binding-card" *ngFor="let item of thirdPartyBindings">
            <div class="binding-card-top">
              <div>
                <div class="binding-card-title">{{ item.name }}</div>
                <div class="binding-card-url">{{ item.webhookUrl }}</div>
              </div>
            </div>

            <div class="binding-events">
              <nz-tag *ngFor="let type of item.eventTypes">{{ getThirdPartyEventTypeLabel(type) }}</nz-tag>
            </div>

            <div class="binding-actions">
              <button
                nz-button
                nzType="default"
                type="button"
                (click)="openThirdPartyBindingEditModal(item)"
                testId="channel-third-party-edit-button"
              >
                {{ 'common.edit' | i18n }}
              </button>
              <button nz-button nzDanger type="button" (click)="unbindThirdPartyServer(item)" testId="channel-third-party-unbind-button">
                {{ 'servicenumber.channel.third-party.unbind-action' | i18n }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </nz-spin>
  </nz-card>
</div>

<nz-modal
  [(nzVisible)]="lineGuideVisible"
  [nzTitle]="'servicenumber.channel.line-guide-title' | i18n"
  [nzWidth]="860"
  [nzCancelText]="'common.close' | i18n"
  [nzFooter]="null"
  nzClassName="service-line-guide-modal"
  (nzOnCancel)="closeLineGuide()"
  [testId]="'channel-line-guide-modal'"
>
  <ng-container *nzModalContent>
    <div class="service-line-guide" [testId]="'channel-line-guide-content'">
      <div class="service-line-guide__lead">
        <strong>{{ 'servicenumber.channel.line-guide-lead-title' | i18n }}</strong>
        <p>{{ 'servicenumber.channel.line-guide-lead-content' | i18n }}</p>
        <div class="service-line-guide__links">
          <a href="https://developers.line.biz/console/" target="_blank" rel="noopener noreferrer">LINE Developers Console</a>
          <a href="https://manager.line.biz/" target="_blank" rel="noopener noreferrer">LINE Official Account Manager</a>
        </div>
      </div>
      <section class="service-line-guide__step" *ngFor="let step of [1, 2, 3, 4, 5, 6, 7]">
        <div class="service-line-guide__step-number">{{ step }}</div>
        <div>
          <h4>{{ 'servicenumber.channel.line-guide-step' + step + '-title' | i18n }}</h4>
          <p>{{ 'servicenumber.channel.line-guide-step' + step + '-content' | i18n }}</p>
          <img
            *ngFor="let imageSource of lineGuideImageSources[step - 1]"
            [src]="'assets/images/guides/line/' + imageSource"
            [alt]="'servicenumber.channel.line-guide-step' + step + '-alt' | i18n"
          />
        </div>
      </section>
    </div>
  </ng-container>
</nz-modal>

<ng-template #emptyThirdPartyBindings>
  <nz-empty [nzNotFoundContent]="'servicenumber.channel.third-party.empty' | i18n" />
</ng-template>

<!-- Line绑定模态框 -->
<nz-modal
  [testId]="'line-bind-modal'"
  [(nzVisible)]="lineModalVisible"
  [nzTitle]="'servicenumber.channel.bind-line-channel' | i18n"
  (nzOnCancel)="handleLineCancel()"
  (nzOnOk)="bindLine()"
  [nzOkLoading]="lineBindLoading"
  [nzContent]="lineModalContent"
>
  <ng-template #lineModalContent>
    <form nz-form [formGroup]="lineForm" testId="line-channel-bind-form">
      <div class="line-bind-readme" testId="service-number-line-bind-readme">
        <div class="line-bind-readme__title">
          <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
          {{ 'servicenumber.channel.line-bind-readme-title' | i18n }}
        </div>
        <p>{{ 'servicenumber.channel.line-bind-readme-content' | i18n }}</p>
        <ul>
          <li>{{ 'servicenumber.channel.line-bind-readme-item1' | i18n }}</li>
          <li>{{ 'servicenumber.channel.line-bind-readme-item2' | i18n }}</li>
          <li>{{ 'servicenumber.channel.line-bind-readme-item3' | i18n }}</li>
          <li>{{ 'servicenumber.channel.line-bind-readme-item4' | i18n }}</li>
        </ul>
      </div>
      <nz-form-item [testId]="'line-channel-id-form-item'">
        <nz-form-label [nzSpan]="6" nzRequired>{{ 'servicenumber.channel.channel-id' | i18n }}</nz-form-label>
        <nz-form-control [nzSpan]="16" [nzErrorTip]="'servicenumber.channel.enter-channel-id' | i18n" [testId]="'line-channel-id-control'">
          <input
            nz-input
            formControlName="channelId"
            [placeholder]="'servicenumber.channel.channel-id-placeholder' | i18n"
            [testId]="'line-channel-id-input'"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item [testId]="'line-channel-secret-form-item'">
        <nz-form-label [nzSpan]="6" nzRequired>{{ 'servicenumber.channel.channel-secret' | i18n }}</nz-form-label>
        <nz-form-control
          [nzSpan]="16"
          [nzErrorTip]="'servicenumber.channel.enter-channel-secret' | i18n"
          [testId]="'line-channel-secret-control'"
        >
          <input
            nz-input
            formControlName="channelSecret"
            [placeholder]="'servicenumber.channel.channel-secret-placeholder' | i18n"
            [testId]="'line-channel-secret-input'"
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item [testId]="'line-provider-id-form-item'">
        <nz-form-label [nzSpan]="6" nzRequired>{{ 'servicenumber.channel.provider-id' | i18n }}</nz-form-label>
        <nz-form-control
          [nzSpan]="16"
          [nzErrorTip]="'servicenumber.channel.enter-provider-id' | i18n"
          [testId]="'line-provider-id-control'"
        >
          <input
            nz-input
            formControlName="providerId"
            [placeholder]="'servicenumber.channel.provider-id-placeholder' | i18n"
            [testId]="'line-provider-id-input'"
          />
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-template>
</nz-modal>

<nz-modal
  nzClassName="third-party-selector-modal"
  nzWrapClassName="third-party-selector-modal-wrap"
  [nzVisible]="thirdPartyBindingModalVisible"
  [nzWidth]="620"
  [nzStyle]="{ top: '64px' }"
  [nzBodyStyle]="{
    height: 'calc(72vh - 120px)',
    'max-height': '560px',
    overflow: 'hidden',
    display: 'flex',
    'flex-direction': 'column',
    padding: '20px 24px'
  }"
  [nzTitle]="'servicenumber.channel.third-party.bind-modal-title' | i18n"
  [nzFooter]="thirdPartySelectorFooter"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closeThirdPartyBindingModal()"
  testId="channel-third-party-selector-modal"
>
  <ng-container *nzModalContent>
    <div class="third-party-selector-content">
      <nz-spin class="third-party-binding-spin" [nzSpinning]="thirdPartyBindingLoading">
        <div class="bind-modal-hint">{{ 'servicenumber.channel.third-party.bind-modal-hint' | i18n }}</div>
        <ng-container *ngIf="bindableThirdPartyServers.length || thirdPartyBindingLoading; else emptyBindableThirdPartyServers">
          <div class="bindable-list-shell bindable-list-shell-modal">
            <div class="bindable-list-header">
              <div class="bindable-list-title">{{ 'servicenumber.channel.third-party.bindable-list-title' | i18n }}</div>
              <div class="bindable-list-count">{{ bindableThirdPartyServers.length }}</div>
            </div>
            <div class="bindable-list-scroll bindable-list-scroll-modal" (scroll)="onBindableListScroll($event)">
              <div class="bindable-list">
                <button
                  type="button"
                  class="bindable-item"
                  *ngFor="let item of bindableThirdPartyServers"
                  (click)="selectThirdPartyServer(item)"
                  [testId]="'channel-third-party-bindable-item-' + item.id"
                >
                  <div class="bindable-main">
                    <div class="bindable-header">
                      <div class="bindable-name">{{ item.name }}</div>
                    </div>
                    <div class="bindable-url">{{ item.webhookUrl }}</div>
                    <div class="bindable-events">
                      <span class="bindable-events-summary" *ngIf="item.eventTypes.length">
                        {{ item.eventTypes.length }} {{ 'servicenumber.channel.third-party.events-configured' | i18n }}
                      </span>
                      <span class="bindable-events-empty" *ngIf="!item.eventTypes.length">
                        {{ 'servicenumber.channel.third-party.no-events-selected' | i18n }}
                      </span>
                    </div>
                  </div>
                  <div class="bindable-checkmark">
                    <i nz-icon nzType="right"></i>
                  </div>
                </button>
              </div>
              <div class="bindable-list-loading" *ngIf="thirdPartyBindingLoading">
                <i nz-icon nzType="loading"></i>
                <span>{{ 'common.loading' | i18n }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </nz-spin>
    </div>
  </ng-container>
</nz-modal>

<ng-template #thirdPartySelectorFooter>
  <button nz-button type="button" (click)="closeThirdPartyBindingModal()" testId="channel-third-party-selector-cancel-button">
    {{ 'common.cancel' | i18n }}
  </button>
</ng-template>

<nz-modal
  nzClassName="third-party-event-modal"
  nzWrapClassName="third-party-event-modal-wrap"
  [nzVisible]="thirdPartyEventModalVisible"
  [nzWidth]="680"
  [nzTitle]="getThirdPartyBindingModalTitleKey() | i18n"
  [nzOkLoading]="thirdPartyBindingSubmitting"
  [nzOkText]="'common.confirm' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closeThirdPartyEventModal()"
  (nzOnOk)="bindThirdPartyServer()"
  testId="channel-third-party-event-modal"
>
  <ng-container *nzModalContent>
    <div class="event-modal-content" *ngIf="getSelectedThirdPartyServer() as selectedServer">
      <div class="bind-modal-hint" *ngIf="isThirdPartyBindingEditing()">
        {{ 'servicenumber.channel.third-party.edit-modal-hint' | i18n }}
      </div>
      <div class="selected-server-card selected-server-card-static">
        <div class="selected-server-name">{{ selectedServer.name }}</div>
        <div class="selected-server-url">{{ selectedServer.webhookUrl }}</div>
      </div>
      <div class="event-select-section event-select-section-standalone">
        <div class="event-select-header">
          <div class="event-select-label">{{ 'tenant.third-party-service.form.events' | i18n }}</div>
        </div>
        <div class="event-checklist">
          <div class="event-check-item" *ngFor="let eventType of thirdPartyEventTypeOptions">
            <label
              nz-checkbox
              [ngModel]="isThirdPartyEventTypeSelected(eventType)"
              (ngModelChange)="toggleThirdPartyEventType(eventType, $event)"
            >
              <span class="event-check-text">{{ getThirdPartyEventTypeLabel(eventType) }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #emptyBindableThirdPartyServers>
  <nz-empty [nzNotFoundContent]="'servicenumber.channel.third-party.bindable-empty' | i18n" />
</ng-template>
